/** Media delivery: ImageKit CDN when linked to S3, else API proxy with resize. */
import { dedupeInflight } from './dedupedFetch';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

let endpoint = (process.env.REACT_APP_IMAGEKIT_URL_ENDPOINT || '').replace(/\/$/, '');
let deliveryReady = null;
let deliveryMode = null;
let mediaDeliveryBase = null;
let mediaVideoDeliveryBase = null;

const configListeners = new Set();

function notifyConfigListeners() {
  const snapshot = getMediaDeliveryConfig();
  configListeners.forEach((fn) => {
    try {
      fn(snapshot);
    } catch (e) {
      console.warn('Media delivery config listener error:', e);
    }
  });
}

export function getMediaDeliveryConfig() {
  return {
    endpoint,
    deliveryReady: deliveryReady === true,
    deliveryMode: deliveryMode || (deliveryReady ? 'imagekit' : 'proxy'),
    mediaDeliveryBase: mediaDeliveryBase || '',
    mediaVideoDeliveryBase: mediaVideoDeliveryBase || ''
  };
}

export function getImageKitEndpoint() {
  return endpoint;
}

export function getImageKitDeliveryReady() {
  return deliveryReady;
}

export function setMediaDeliveryConfig({
  imageKitUrlEndpoint,
  deliveryReady: ready,
  deliveryMode: mode,
  mediaDeliveryBase: proxyBase,
  mediaVideoDeliveryBase: videoProxyBase
} = {}) {
  if (imageKitUrlEndpoint !== undefined) {
    endpoint = (imageKitUrlEndpoint || '').replace(/\/$/, '');
  }
  if (ready !== undefined) {
    deliveryReady = ready === true ? true : ready === false ? false : null;
  }
  if (mode !== undefined) {
    deliveryMode = mode || null;
  }
  if (proxyBase !== undefined) {
    mediaDeliveryBase = (proxyBase || '').replace(/\/$/, '');
  }
  if (videoProxyBase !== undefined) {
    mediaVideoDeliveryBase = (videoProxyBase || '').replace(/\/$/, '');
  }
  notifyConfigListeners();
}

export function subscribeMediaDeliveryConfig(listener) {
  configListeners.add(listener);
  listener(getMediaDeliveryConfig());
  return () => configListeners.delete(listener);
}

/** @deprecated */
export function subscribeImageKitEndpoint(listener) {
  return subscribeMediaDeliveryConfig((cfg) => listener(cfg.endpoint));
}

/** @deprecated */
export function subscribeImageKitDeliveryReady(listener) {
  return subscribeMediaDeliveryConfig((cfg) => listener(cfg.deliveryReady));
}

export function loadImageKitConfig() {
  return dedupeInflight(
    'images:delivery-config',
    async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/images/delivery-config`);
        if (!res.ok) {
          setMediaDeliveryConfig({
            deliveryReady: false,
            deliveryMode: 'proxy',
            mediaDeliveryBase: `${API_BASE_URL}/api/images/deliver`,
            mediaVideoDeliveryBase: `${API_BASE_URL}/api/images/deliver-video`
          });
          return getMediaDeliveryConfig();
        }
        const data = await res.json();
        setMediaDeliveryConfig({
          imageKitUrlEndpoint: data.imageKitUrlEndpoint,
          deliveryReady: Boolean(data.deliveryReady),
          deliveryMode: data.deliveryMode,
          mediaDeliveryBase: data.mediaDeliveryBase,
          mediaVideoDeliveryBase: data.mediaVideoDeliveryBase
        });
        return getMediaDeliveryConfig();
      } catch {
        setMediaDeliveryConfig({
          deliveryReady: false,
          deliveryMode: 'proxy',
          mediaDeliveryBase: `${API_BASE_URL}/api/images/deliver`,
          mediaVideoDeliveryBase: `${API_BASE_URL}/api/images/deliver-video`
        });
        return getMediaDeliveryConfig();
      }
    },
    { cacheMs: 300000 }
  );
}
